import axios from 'ps-components/lib/apiClient';
import { useQuery } from "react-query"
import { useAppState } from "../redux"
import { QueryKeys } from '../../constants/query-keys';

export const useUniqueJobCodeKeys = (versionId: string | number) => {
  const appState = useAppState()
  const { csrf_timestamp, csrf_token } = appState.session

  const getUniqueJobCodeKeys = async (): Promise<string[]> => {
    const response = await axios.apiGet(`/api/market-pricing/global-job-pricing/getUniqueJobCodeKeys?versionId=${versionId}&csrf_token=${csrf_token}&csrf_timestamp=${csrf_timestamp}`)
    return response.data.jobCodeKeys || []
  }

  const query = useQuery([QueryKeys.GLO_JAM_UNIQUE_JOB_CODE_KEYS, { versionId }], getUniqueJobCodeKeys)

  return query
}
